export default __webpack_public_path__ + "static/JK1-65d321046c5b67cd90ce8bbb1602c8bc.png";